export const SET_NEW_MESSAGE_FLAG = 'SET_NEW_MESSAGE_FLAG';
export const SET_CHAT_LIST = 'SET_CHAT_LIST';
export const SET_CHAT_LIST_AND_TOTAL = 'SET_CHAT_LIST_AND_TOTAL';
export const SET_CHAT_LIST_LOADING = 'SET_CHAT_LIST_LOADING';
export const SET_MESSAGES_LIST = 'SET_MESSAGES_LIST';
export const ADD_MESSAGE_TO_LIST = 'ADD_MESSAGE_TO_LIST';
export const SET_MESSAGES_LIST_LOADING = 'SET_MESSAGES_LIST_LOADING';
export const MARK_CHAT_AS_READ = 'MARK_CHAT_AS_READ';
